export default __webpack_public_path__ + "static/media/department-outline-16px.2c4c0544.svg";